import { render, staticRenderFns } from "./TerraceSurface.vue?vue&type=template&id=6ef4de8e&"
import script from "./TerraceSurface.vue?vue&type=script&lang=ts&"
export * from "./TerraceSurface.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports